import Factory from './utils/factory'

const FlatfinderItem = Factory({
  data: {
    geometry: null,
    type: null,
    description: null,
    redirectUrl: null,
    thumbnailType: 'cover',
    image: null,
  },
  reference: null,
})

const FlatfinderSunlightCondition = Factory({
  image: null,
  date: null,
  time: null,
  isDefault: false,
})

const FlatfinderFrame = Factory({
  image: null,
  cardinalDirection: null,
  items: [FlatfinderItem],
  sunlightConditions: [FlatfinderSunlightCondition],
})

export { FlatfinderFrame, FlatfinderItem, FlatfinderSunlightCondition }

export default Factory({
  id: null,
  name: null,
  description: null,
  parent: null,
  isEntry: false,
  version: 'leaflet-v1',

  frames: [FlatfinderFrame],
  customFields: null,
})
